import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Card, CardActionArea, Typography } from '@mui/material';

const AdminCenterOptionTileView = ({ pathName, title, description, icon: Icon }) => {
  const navigate = useNavigate();

  return (
    <Card
      variant='outlined'
      sx={{
        height: '100%',
        transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        '&:hover': { borderColor: 'primary.main', boxShadow: 2 },
        '&:hover .admin-tile-chevron': { color: 'primary.main', transform: 'translateX(2px)' },
      }}
    >
      <CardActionArea
        onClick={() => navigate(pathName)}
        sx={{ height: '100%', p: 2, display: 'flex', alignItems: 'flex-start', gap: 2 }}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: 40,
            height: 40,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'action.hover',
            color: 'primary.main',
          }}
        >
          <Icon fontSize='small' />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant='subtitle1' sx={{ fontWeight: 600, lineHeight: 1.3, mb: 0.5 }}>
            {title}
          </Typography>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              minHeight: '2lh',
            }}
          >
            {description}
          </Typography>
        </Box>
        <ChevronRightIcon
          className='admin-tile-chevron'
          sx={{ flexShrink: 0, color: 'text.disabled', transition: 'all 0.2s ease-in-out' }}
        />
      </CardActionArea>
    </Card>
  );
};

export default AdminCenterOptionTileView;

AdminCenterOptionTileView.propTypes = {
  pathName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
};
